import {
  UNDEFINED_STATUS
} from './action-status';

import {
  UNDEFINED_CONTENT_TYPE
} from './active-content-type';

import {
  UNDEFINED_CLEANUP_STAGE
} from './cleanup-stage';

export default function initialState() {
  return {
    moduleName: 'wrh-dashboard',
    navMenuItems: [],
    activeNavMenuItemId: '',
    storageSpace: { used: 0, total: 0 },
    setupArchivePasswordStatus: UNDEFINED_STATUS,
    archiveDeletionStatus: UNDEFINED_STATUS,
    cleanupStatus: UNDEFINED_STATUS,
    contentItems: [],
    fetchNavMenuItemsStatus: UNDEFINED_STATUS,
    fetchStorageSpaceStatus: UNDEFINED_STATUS,
    fetchContentItemsStatus: UNDEFINED_STATUS,
    postLoginOpenArchiveId: { id: '', baseName: '' },
    postLoginOpenNavMenuId: { id: '' },
    activeContentType: UNDEFINED_CONTENT_TYPE,
    sharedContentItems: [],
    fetchSharedContentItemsStatus: UNDEFINED_STATUS,
    userSubscription: {},
    userSubscriptionType: '',
    appFeatures: {},
    fileVersions: [],
    fetchFileVersionsStatus: UNDEFINED_STATUS,
    fdLink: '',
    fetchFdLinkStatus: UNDEFINED_STATUS,
    signFileLink: '',
    signFileStatus: UNDEFINED_STATUS,
    sharedLink: {},
    createSharedLinkStatus: UNDEFINED_STATUS,
    deleteSharedLinkStatus: UNDEFINED_STATUS,
    sharedLinkSettings: {},
    fetchSharedLinkStatus: UNDEFINED_STATUS,
    updateSharedLinkStatus: UNDEFINED_STATUS,
    searchEnabled: false,
    brandName: 'Acronis Cloud',
    spaceFreeAfterCleanup: 0,
    cleanupBoxName: '',
    cleanupProgressPercent: 0,
    cleanupStage: UNDEFINED_CLEANUP_STAGE,
    searchResultReceived: false,
    activeVersionPath: '',
    activeVolumePath: '',
    activeFolderItem: { path: '', displayName: '', isSearchFolder: false }
  };
}
